import React, { useEffect, useState } from 'react';
import { FilterState, Filters } from '../Filters';
import { defaultDateRange } from '../../../../components/candidate_experience/Filters/filterState';
import cloneDeep from 'lodash.clonedeep';
import { readHash, writeHash } from '../../../../utils/location';
import { PipelinePerformanceBody } from '../PipelinePerformanceBody';
import { lodashCustomCompare } from '../../../../utils/lodash';
import _ from 'lodash';

const DEFAULT_FILTER_STATE: Readonly<FilterState> = {
  filterBy: { label: 'Departments', value: 'department' },
  entries: [],
  dateRange: defaultDateRange(),
  locations: [],
};

function hashedFilterState() {
  return readHash<FilterState>(DEFAULT_FILTER_STATE);
}

export default function PipelinePerformancePage() {
  const [appliedFilterState, setAppliedFilterState] = useState<FilterState>(
    hashedFilterState(),
  );
  const [draftFilterState, setDraftFilterState] = useState<FilterState>(
    cloneDeep(appliedFilterState),
  );

  function handleFilterUpdate(
    name: keyof FilterState,
    value: FilterState[keyof FilterState],
  ) {
    const newFilterState = cloneDeep(draftFilterState);
    newFilterState[name] = value as any; // Whatever.
    if (name === 'filterBy') {
      if (newFilterState.filterBy.value === appliedFilterState.filterBy.value) {
        newFilterState.entries = appliedFilterState.entries;
      } else {
        newFilterState.entries = [];
      }
    }
    setDraftFilterState(newFilterState);
  }

  function handleResetClick() {
    setDraftFilterState(DEFAULT_FILTER_STATE);
    setAppliedFilterState(DEFAULT_FILTER_STATE);
  }

  function handleApplyClick() {
    setAppliedFilterState(draftFilterState);
  }

  useEffect(() => {
    writeHash(appliedFilterState);
  }, [appliedFilterState]);

  useEffect(() => {
    function handlePopState() {
      const newFilterState = hashedFilterState();
      if (
        !_.isEqualWith(newFilterState, appliedFilterState, lodashCustomCompare)
      ) {
        setAppliedFilterState(newFilterState);
      }
    }

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <main>
      <div className='d-flex flex-column align-items-start gap-3'>
        <div className='d-flex w-100'>
          <h1 className='my-0 me-auto'>Pipeline Performance</h1>
        </div>
        <Filters
          filterState={draftFilterState}
          onFilterUpdate={handleFilterUpdate}
          onResetClick={handleResetClick}
          onApplyClick={handleApplyClick}
        />
        <PipelinePerformanceBody filterState={appliedFilterState} />
      </div>
    </main>
  );
}
